import { cn } from '@/shared/utils/cn'

interface CategoryFilterProps {
  categories: string[]
  /** Categoría seleccionada; `null` = Todas. */
  value: string | null
  onChange: (category: string | null) => void
  className?: string
}

/**
 * Filtro de categorías como fila de chips: "Todas" + una por categoría.
 * Compartido por el catálogo de servicios y los servicios activos del negocio.
 */
export function CategoryFilter({
  categories,
  value,
  onChange,
  className,
}: CategoryFilterProps) {
  if (categories.length === 0) return null

  const chip = (active: boolean) =>
    cn(
      'rounded-full px-3 py-1.5 text-xs font-medium transition-colors',
      active
        ? 'bg-brand text-white'
        : 'border border-line bg-panel text-ink-muted hover:bg-surface hover:text-ink',
    )

  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      <button type="button" onClick={() => onChange(null)} className={chip(value === null)}>
        Todas
      </button>
      {categories.map((c) => (
        <button
          key={c}
          type="button"
          onClick={() => onChange(c)}
          className={chip(value === c)}
        >
          {c}
        </button>
      ))}
    </div>
  )
}
